export const CLASS_NAME_COMPONENT_CHECKBOX = "tg-checkbox";
export const CLASS_NAME_COMPONENT_FILE_INPUT = "tg-file-input";
